import { render } from "./WriteOffs.vue?vue&type=template&id=1ae6a33c&scoped=true&ts=true"
import script from "./WriteOffs.vue?vue&type=script&lang=ts"
export * from "./WriteOffs.vue?vue&type=script&lang=ts"

import "./WriteOffs.vue?vue&type=style&index=0&id=1ae6a33c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae6a33c"]])

export default __exports__